<template>
    <div>
        <HeaderNav v-if="!isWeixinBrowser()" :beforecolor="'#fff'" :backcolor="getSuccessBuyButtonColor()" @returnBack="goToBack"></HeaderNav>
        <div class="imgLazyLoadHead">
            <div v-if="noShowGuideWordsAfter == 0"  class="bubbleContainer" @click="guideWordsAfterClick">
                <div class="text">本书全部词汇</div>
                <div class="img"><img src="../../../assets/play_arrow.png"/></div>
            </div>
            <img v-bind:src="getheadImage()"/>
        </div>
        <div class="page-navbar">
            <mt-navbar class="page-part" v-model="selected">
                <mt-tab-item id="1" :style="selected == 1 ? isSelected() : {cursor: 'pointer'}">课程列表</mt-tab-item>
                <mt-tab-item id="2" :style="selected == 2 ? isSelected() : {cursor: 'pointer'}">词汇表</mt-tab-item>
            </mt-navbar>
            <mt-tab-container v-model="selected">
                <mt-tab-container-item id="1">
                    <div class="course_list_content" :style="{backgroundColor:getSuccessSubCourseColor()}">
                        <div class="group_lesson_item" v-for="(item,index) in objSuccessCourseHomeInfo.groupLesson" :key="index">
                            <div class="group_lesson_title">
                                <div class="chinese" :style="{color:getSuccessCourseColor()}">{{item.readingSkillsChinese}}</div>
                                <div class="english" :style="{color:getSuccessCourseColor()}">{{item.readingSkillsEnglish}}</div>
                            </div>
                            <div class="lesson_item" v-for="(itemLesson,indexLesson) in item.lessonArray" :key="indexLesson" @click="lessonItemClick(itemLesson.pk)">
                                <div class="lesson_title">
                                    <div class="no" :style="{color:getSuccessCourseColor()}">#{{itemLesson.lessonNo}}</div>
                                    <div class="name" :style="{color:getSuccessCourseColor()}">{{itemLesson.name}}</div>
                                    <div class="down">
                                        <img v-if="selectedLessonPk != itemLesson.pk" src="../../../assets/chevron-down.png"/>
                                    </div>
                                    <div class="clear"></div>
                                    <img class="img2" v-if="getCount(itemLesson.finish) === 1" src="../../../assets/240_course_finished.png"/>
                                </div>
                                <div class="lesson_action" :style="{display:selectedLessonPk === itemLesson.pk ? '' : 'none'}">
                                    <div  v-if="noShowGuideWordsAfter2 == 0"  class="bubbleContainer2" @click="guideWordsAfter2Click">
                                        <div class="text">点击圆圈进入课程</div>
                                        <div class="img"><img src="../../../assets/play_arrow.png"/></div>
                                    </div>
                                    <div class="lesson_action_j">
                                        <div class="learn_word" @click="learnWordClick(itemLesson.pk)">
                                            <img src="../../../assets/learn_word.png"/>
                                            <span>学词汇<br/>听音频</span>
                                        </div>
                                        <div class="carding" @click="cardingClick(itemLesson.pk)">
                                            <img src="../../../assets/carding.png"/>
                                            <span>文章结构<br/>梳理</span>
                                        </div>
                                        <div class="explain" @click="explainClick(itemLesson.pk)">
                                            <img src="../../../assets/explain.png"/>
                                            <span>阅读策略<br/>讲解</span>
                                        </div>
                                        <div class="clear"></div>
                                    </div>
                                    <div class="lesson_action_d">
                                        <div v-if="getCount(itemLesson.finish) === 0" class="do_punch" :style="{backgroundColor:'#FFAA00'}" @click="punchClick(index, itemLesson)">学完了, 打个卡</div>
                                        <div v-else class="punched" :style="{backgroundColor:getSuccessCourseColor()}" @click="punchClick(index, itemLesson)">
                                            <img src="../../../assets/white_checked.png"/>
                                            <span>本课已完成</span>
                                            <div class-="clear"></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="lesson_list_bottom"></div>
                    </div>
                </mt-tab-container-item>
                <mt-tab-container-item id="2">
                    <div v-bind:style="{backgroundColor:getSuccessSubCourseColor()}">
                        <div class="Words_glossary_item" v-for="(item,index) in WordsGlossaryArray" :key="index">
                            <div :id="'section_' + item.initial" :style="{'padding-top':(44 + getStatusHeight())+'px', 'margin-top': '-'+(44 + getStatusHeight())+'px'}">
                                <div class="section_title">{{item.initial}}</div>
                            </div>
                            <div class="Words_glossary_wordsitem" v-for="(section,index) in item.sections" :key="index"
                                 @click="wordClick(section.youdaoUrl, section.pk, section.word)">
                                <div class="Word" :style="{color:isEmpty(section.youdaoUrl) ? '#ff5050' : '#333333'}">
                                    {{section.word}}
                                    <span v-if="getCount(section.subscript) > 0">{{getCount(section.subscript)}}</span>
                                </div>
                                <div class="point">···············</div>
                                <div class="lesson_name">Lesson {{section.lessonNo}}</div>
                                <div class="clear"></div>
                            </div>
                        </div>
                    </div>
                    <div class="Words_glossary_indexs">
                        <div class="Words_glossary_indexsitem" v-for="(item,index) in WordsGlossaryArray" :key="index"
                             @click="scrollToPositin(item.initial)">
                            {{item.initial}}
                        </div>
                    </div>
                </mt-tab-container-item>
            </mt-tab-container>
        </div>
    </div>
</template>
<script>
    import Vue from 'vue'

    export default {
        data() {
            return {
                selected: '1',
                courseId: parseInt(this.$route.query.courseId),
                objSuccessCourseHomeInfo: {},
                totalPartCount: 4,
                WordsGlossaryArray: [],
                noShowGuideWordsAfter:1,
                noShowGuideWordsAfter2:1,
                selectedLessonPk:0
            }
        },
        watch : {
            selected(newV){
                window.console.log(newV);

                if (parseInt(newV) === 2) {
                    this.guideWordsAfterClick();
                }
            }
        },
        methods: {
            goToBack() {
                let that = this;
                let token = that.$store.state.token;
                let userid = that.$store.state.userid.toString();

                if (!this.isEmpty(token) && !this.isEmpty(userid) && token.length > userid.length) {
                    if (this.isAppIos()) {
                        var vUrl = "readingclubapp:gobackMyCourse";
                        document.location = vUrl;
                    }

                    if (this.isAppAndroid()) {
                        window.note.gobackMyCourse();
                    }
                } else {
                    this.goBack(this.$router);
                }
            },
            getStatusHeight() {
                let statusHeight = this.getCount(this.$store.state.statusheight);

                if (statusHeight === 0) {
                    statusHeight = 20;
                }

                return statusHeight;
            },
            punchClick:function(groupIndex, itemLesson) {
                let that = this;
                let vFinish = that.getCount(itemLesson.finish) === 1 ? 0 : 1;
                let url = "success/setFinish/" + itemLesson.pk + "/" + vFinish;
                that.$axios.get(url).then((response) => {
                    if (response.data === 1) {
                        that.objSuccessCourseHomeInfo.groupLesson.forEach((item, index) => {
                            if (index === groupIndex) {
                                item.lessonArray.forEach((item2, index2) => {
                                    if (item2.pk === itemLesson.pk) {
                                        item2.finish = vFinish;
                                        Vue.set(item.lessonArray, index2, item2);
                                        Vue.set(that.objSuccessCourseHomeInfo.groupLesson, index, item);
                                    }
                                });
                            }
                        });
                    }
                }).catch(function (error) {
                    window.console.log(error)
                });
            },
            lessonItemClick:function(pk) {
                if (this.selectedLessonPk === pk){
                    return;
                }

                this.selectedLessonPk = pk;
            },
            learnWordClick:function(pk){
                this.$router.push({name: "SLesson", query: {lessonId: pk}})
            },
            cardingClick:function(pk){
                this.guideWordsAfter2Click();
                this.$router.push({name: "SQuestion", query: {lessonId: pk}})
            },
            explainClick:function(pk){
                this.$router.push({name: "SStrategy", query: {lessonId: pk}})
            },
            getheadImage:function(){
                return require('@/assets/s' + this.courseId + '.jpg');
            },
            guideWordsAfterClick:function(){
                let that = this;

                if (that.noShowGuideWordsAfter === 1) {
                    return;
                }

                that.$axios.get("/success/saveGuidePrompt/key1").then((response) => {
                    let vResult = that.getCount(response.data);
                    window.console.log("/success/saveGuidePrompt/key1:" + response.data)

                    if (vResult === 1) {
                        that.noShowGuideWordsAfter = 1;
                    }
                }).catch(function (error) {
                    window.console.log(error)
                });
            },
            guideWordsAfter2Click:function(){
                let that = this;

                if (that.noShowGuideWordsAfter2 === 1) {
                    return;
                }

                that.$axios.get("/success/saveGuidePrompt/key2").then((response) => {
                    let vResult = that.getCount(response.data);
                    window.console.log("/success/saveGuidePrompt/key2:" + response.data)

                    if (vResult === 1) {
                        that.noShowGuideWordsAfter2 = 1;
                    }
                }).catch(function (error) {
                    window.console.log(error)
                });
            },
            lessonClick: function (pk) {
                this.$router.push({
                    name: 'wordLesson',
                    query: {courseId: this.courseId, lessonId: pk}
                });
            },
            wordClick: function (youdaoUrl, wordId, word) {
                if (!this.isEmpty(youdaoUrl)) {
                    this.$router.push({name: 'pageView', query: {url: "https://m.youdao.com/dict?le=eng&q=" + word}});
                } else {
                    this.$router.push({
                        name: 'SCard', query: {wordId: wordId}
                    });
                }
            },
            isSelected() {
                return {
                    color: this.getSuccessCourseColor(),
                    'border-bottom': '3px solid ' + this.getSuccessCourseColor(),
                    cursor: 'pointer'
                };
            },
            getFirstLettersArray(array) {
                let firstLetters = [];

                array.forEach(item => {
                    if (firstLetters.indexOf(item.firstLetter) === -1) {
                        firstLetters.push(item.firstLetter);
                    }
                });

                return firstLetters;
            },
            scrollToPositin(section) {
                document.getElementById('section_' + section).scrollIntoView();
            }
        },
        beforeCreate() {
            let that = this;
            let vCourseId = parseInt(that.$route.query.courseId);
            let url = "success/getHomeInfo/" + vCourseId + "/1";

            that.$axios.get(url).then((response) => {
                window.console.log("success/getHomeInfo/：" + JSON.stringify(response.data))
                that.objSuccessCourseHomeInfo = response.data;
                that.noShowGuideWordsAfter = that.getCount(that.objSuccessCourseHomeInfo.key1);
                that.noShowGuideWordsAfter2 = that.getCount(that.objSuccessCourseHomeInfo.key2);

                that.objSuccessCourseHomeInfo.groupLesson.forEach((item) => {
                    item.lessonArray.forEach((itemLesson) => {
                        if (that.getCount(itemLesson.finish) === 0 && that.selectedLessonPk === 0) {
                            that.selectedLessonPk = itemLesson.pk;
                        }
                    });
                });
            }).catch(function (error) {
                window.console.log(error)
            });

            let url2 = "success/getGlossary/" + vCourseId;

            that.$axios.get(url2).then((response) => {
                let wordsGlossarys = response.data;
                let firstLetters = that.getFirstLettersArray(wordsGlossarys);

                firstLetters.forEach(initial => {
                    let sections = wordsGlossarys.filter(wordsGlossary => wordsGlossary.firstLetter === initial);
                    that.WordsGlossaryArray.push({
                        initial,
                        sections
                    });
                })
            }).catch(function (error) {
                window.console.log(error)
            });
        },
        mounted() {
            window.SuccessAfterScrollTop = 0;
        },
        beforeRouteLeave(to, from, next) {
            window.SuccessAfterScrollTop = document.documentElement.scrollTop || document.body.scrollTop;
            next()
        },
        activated() {
            window.scrollTo(0, window.SuccessAfterScrollTop);
        }
    }
</script>
<style scoped>
    .imgLazyLoadHead {
        position: relative;
        padding: 0;
    }
    .imgLazyLoadHead img {
        display: block;
        width: 100%;
        margin: auto;
    }
    .course_list_content {
        height: auto;
    }
    .clear {
        clear: both;
        line-height: 0;
        font-size: 0;
        height: 0;
        over-flow: hidden;
    }
    .tab_title {
        font-size: 15px;
        font-weight: bold;
    }
    /*课程列表样式*/
    .group_lesson_item {
        padding-top: 30px;
        margin-left: 10px;
        margin-right: 10px;
    }
    .group_lesson_item .group_lesson_title {
        text-align: center;
        padding-top: 5px;
        padding-bottom: 5px;
        border-radius: 5px;
        -webkit-border-radius: 5px;
        -moz-border-radius: 5px;
    }
    .group_lesson_item .group_lesson_title .chinese {
        font-size: 25px;
        font-weight: bold;
    }
    .group_lesson_item .group_lesson_title .english {
        font-size: 15px;
    }
    .lesson_item {
        position: relative;
        background-color: white;
        margin-top: 10px;
        margin-left: 5px;
        margin-right: 5px;
        border-radius: 5px;
        -webkit-border-radius: 5px;
        -moz-border-radius: 5px;
    }
    .lesson_item .lesson_title {
        padding-top: 15px;
        padding-bottom: 15px;
        display: flex;
        align-items: center;
    }
    .lesson_item .lesson_title .no {
        float: left;
        width: 40px;
        font-size: 20px;
        font-weight: bold;
        margin-left: 15px;
    }
    .lesson_item .lesson_title .name {
        width: calc(100% - 90px);
        font-size: 20px;
        font-weight: bold;
        text-align: center;
    }
    .lesson_item .lesson_title .down {
        margin-right: 15px;
        height: 25px;
    }
    .lesson_item .lesson_title .down img {
        width: 25px;
    }
    .lesson_item .lesson_title .img2 {
        position: absolute;
        top: 1px;
        right: 10px;
        margin-top: 2px;
        -webkit-transform: translateY(5px);
        width: 55px;
    }
    .lesson_item .lesson_action {
        padding-bottom:15px;
    }
    .lesson_item .lesson_action .lesson_action_j img {
        width: 60px;
    }
    .lesson_item .lesson_action .lesson_action_j span {
        display: block;
        color: #333333;
        font-size: 13px;
        font-weight: bold;
    }
    .lesson_item .lesson_action .lesson_action_j .learn_word {
        float: left;
        width: calc(100%/3);
        text-align: center;
    }
    .lesson_item .lesson_action .lesson_action_j .carding {
        float: left;
        width: calc(100%/3);
        text-align: center;
    }
    .lesson_item .lesson_action .lesson_action_j .explain {
        float: left;
        width: calc(100%/3);
        text-align: center;
    }
    .lesson_item .lesson_action .lesson_action_d {
        margin-top: 15px;
        text-align: center;
        height: 34px;
        font-size: 13px;
    }
    .lesson_item .lesson_action .lesson_action_d .do_punch {
        display: inline-block;
        height:34px;
        line-height: 34px;
        color: white;
        padding-left:15px;
        padding-right:15px;
        border-radius: 17px;
        -webkit-border-radius: 17px;
        -moz-border-radius: 17px;
    }
    .lesson_item .lesson_action .lesson_action_d .punched {
        display: inline-block;
        height:34px;
        line-height: 34px;
        color: white;
        padding-left:15px;
        padding-right:15px;
        border-radius: 17px;
        -webkit-border-radius: 17px;
        -moz-border-radius: 17px;
    }
    .lesson_item .lesson_action .lesson_action_d .punched img {
        width: 20px;
        float: left;
        margin-top:6px;
    }
    .lesson_item .lesson_action .lesson_action_d .punched span {
        float: left;
    }
    /*词汇表样式*/
    .Words_glossary_item .section_title {
        background-color: #f4f4f4;
        text-align: left;
        height: 25px;
        font-size: 14px;
        color: #666666;
        line-height: 25px;
        padding-left: 15px;
    }
    .Words_glossary_wordsitem {
        position: relative;
        height: 60px;
    }
    .Words_glossary_wordsitem .Word {
        position: absolute;
        text-align: left;
        font-size: 16px;
        font-weight: bold;
        color: #333333;
        padding: 5px 16px 5px 16px;
        left: 20px;
        top: 50%;
        -webkit-transform: translateY(-50%);
        background-color: white;
        border-radius: 6px;
        -webkit-border-radius: 6px;
        -moz-border-radius: 6px;
    }
    .Words_glossary_wordsitem .Word span {
        position: absolute;
        top: 3px;
        right: 5px;
        font-size: 10px;
        color: #999999;
        font-weight: normal;
    }
    .Words_glossary_wordsitem .point {
        text-align: center;
        font-size: 14px;
        color: white;
        position: absolute;
        left: 50%;
        top: 50%;
        -webkit-transform: translateX(-50%) translateY(-50%);
    }
    .Words_glossary_wordsitem .lesson_name {
        position: absolute;
        text-align: left;
        right: 30px;
        top: 50%;
        -webkit-transform: translateY(-50%);
        color: white;
        font-size: 15px;
    }
    .Words_glossary_indexs {
        position: fixed;
        bottom: 30px;
        right: 0;
        z-index: 999;
    }
    .Words_glossary_indexs .Words_glossary_indexsitem {
        font-size: 10px;
        font-weight: bold;
        color: #333333;
        height: 15px;
        width: 25px;
    }
    .bubbleContainer{
        position: absolute;
        bottom: 0px;
        left: calc(50% + (50% - 120px)/2);
        padding-bottom: 6px;
    }
    .bubbleContainer .text {
        color: white;
        background-color: #fda228;
        border-radius: 5px;
        -webkit-border-radius: 5px;
        -moz-border-radius: 5px;
        padding: 3px 15px 3px 15px;
        font-size: 15px;
        font-weight: bold;
    }
    .bubbleContainer .img {
        position: absolute;
        bottom: 0;
        width: 12px;
        left: 50%;
        -webkit-transform: translateX(-50%);
    }
    .bubbleContainer .img img {
        width: 12px;
    }
    .bubbleContainer2{
        position: absolute;
        top: 25px;
        left: calc((100% - 150px)/2);
        padding-bottom: 12px;
    }
    .bubbleContainer2 .text {
        color: white;
        background-color: #fda228;
        border-radius: 5px;
        -webkit-border-radius: 5px;
        -moz-border-radius: 5px;
        padding: 3px 15px 3px 15px;
        font-size: 15px;
        font-weight: bold;
    }
    .bubbleContainer2 .img {
        position: absolute;
        bottom: 0px;
        width: 12px;
        left: 50%;
        -webkit-transform: translateX(-50%);
    }
    .bubbleContainer2 .img img {
        width: 12px;
    }
    .lesson_list_bottom {
        height: 50px;
    }
</style>
